import { useEffect,useState } from 'react'
import { api } from '../../api/client'
export default function CompanyAssignment({companyId,assigned,saved}:{companyId:string;assigned:string|null;saved:()=>Promise<void>}) {
  const [analysts,setAnalysts]=useState<Awaited<ReturnType<typeof api.analysts>>>([])
  const [selected,setSelected]=useState(assigned ?? '')
  const [reason,setReason]=useState('')
  const [busy,setBusy]=useState(false)
  const [error,setError]=useState('')
  useEffect(()=>{setSelected(assigned ?? '')},[assigned,companyId])
  useEffect(()=>{let live=true;api.analysts().then(rows=>{if(live)setAnalysts(rows)}).catch(e=>{if(live)setError(e.message)});return()=>{live=false}},[])
  return <details className="agent-stage" style={{marginBottom:'1.5rem'}}><summary>Assign analyst</summary>
    <p className="muted">Choose the analyst responsible for this company and future scheduling.</p>
    {error && <p className="notice crit" role="alert">{error}</p>}
    <form className="reply" onSubmit={async e=>{
      e.preventDefault();setBusy(true);setError('')
      try{await api.assignAnalyst(companyId,selected || null,assigned,reason);await saved();setReason('')}
      catch(e){setError(e instanceof Error?e.message:'Could not assign analyst')}
      finally{setBusy(false)}
    }}><label>Analyst <select className="select" value={selected} disabled={busy} onChange={e=>setSelected(e.target.value)}><option value="">Unassigned</option>{analysts.map(a=><option key={a.id} value={a.id}>{a.name} ({a.email})</option>)}</select></label>
      <label>Reason <input className="input" required maxLength={2000} value={reason} disabled={busy} onChange={e=>setReason(e.target.value)}/></label>
      <div><button className="btn small secondary" disabled={busy || selected===(assigned ?? '') || !reason.trim()}>Save assignment</button></div>
    </form>
  </details>
}
